import { render, staticRenderFns } from "./ReadTecnicos.vue?vue&type=template&id=ed58c5ca"
import script from "./ReadTecnicos.vue?vue&type=script&lang=js"
export * from "./ReadTecnicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports